import { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from 'react';

const MobileNavbarChromeContext = createContext(null);

/** 手机顶栏左侧展示的页面标题（由 AppWorkbenchLayout 注册，Header 读取） */
export const MobileNavbarChromeProvider = ({ children }) => {
	const [chrome, setChromeState] = useState(null);

	const setChrome = useCallback((next) => {
		setChromeState(next);
	}, []);

	const value = useMemo(() => ({ chrome, setChrome }), [chrome, setChrome]);

	return <MobileNavbarChromeContext.Provider value={value}>{children}</MobileNavbarChromeContext.Provider>;
};

export const useOptionalMobileNavbarChrome = () => {
	const context = useContext(MobileNavbarChromeContext);
	return context?.chrome ?? null;
};

/** 手机工作台页注册顶栏标题；卸载或 config 为空时清除 */
export const useRegisterMobileNavbarChrome = (config) => {
	const context = useContext(MobileNavbarChromeContext);

	if (!context) {
		throw new Error('useRegisterMobileNavbarChrome must be used within MobileNavbarChromeProvider');
	}

	const { setChrome } = context;

	useLayoutEffect(() => {
		if (config?.pageTitle) {
			setChrome(config);
		} else {
			setChrome(null);
		}

		return () => setChrome(null);
	}, [config, setChrome]);
};
